import React, { Fragment, useState } from "react";
import { PaymentContainer, HyperLink } from "../../PaymentHistory/Styles";
import { TableWrapper } from "../../FinalApprover/index";
import _ from "lodash";
import queryString from "query-string";
import CustomTable from "../../FinalApprover/component/CustomTable";
import { getErrorMessage } from "../../../../helpers/functions";
import { useSnackbar } from "notistack";
import MeetingService from "../../../../services/MeetingService";
import { Bold } from "../../RecordingsPage";
import { navigate } from "@reach/router";

async function getMeetingUrlArbDetails(query = "") {
  try {
    const response = await MeetingService.meetingRecordingDetArb(query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

const ArbitratorRecordings = ({ MTRef, meetingId }) => {
  const [state, setState] = useState({});
  const placeholderText = "Search recordings";
  const { enqueueSnackbar } = useSnackbar();

  const columns = [
    {
      field: "Id",
      title: "Id",
      sorting: false,
      render: (rowData) => (
        <Bold style={{ paddingLeft: "12px" }}>{rowData?.id}</Bold>
      ),
      headerStyle: {
        paddingLeft: "26px",
      },
    },
    {
      field: "name",
      title: "Recording Name",
      sorting: false,
      render: (rowData) =>
        rowData?.RecordingUrl ? (
          <HyperLink
            onClick={() => {
              window.open(rowData?.RecordingUrl);
            }}
          >
            {rowData?.name}
          </HyperLink>
        ) : (
          <div style={{ paddingLeft: "15px" }}>{"-"}</div>
        ),
    },
    {
      field: "duration",
      title: "Duration",
      sorting: false,
      render: (rowData) =>
        rowData?.duration ? (
          <Bold style={{ paddingLeft: "15px" }}>{rowData?.duration}</Bold>
        ) : (
          <div style={{ paddingLeft: "15px" }}>{"-"}</div>
        ),
    },
    {
      field: "audioFileName",
      title: "Live Transcript",
      sorting: false,
      render: (rowData) =>
        rowData?.audioFileUrl ? (
          <HyperLink
            onClick={() =>
              navigate(
                `/dashboard/case-manager/generic-meeting/transcription`,
                {
                  state: rowData,
                },
              )
            }
          >
            {rowData?.audioFileName}
          </HyperLink>
        ) : (
          <div style={{ paddingLeft: "15px" }}>{"-"}</div>
        ),
    },
    {
      field: "totalConfidence",
      title: "Total Confidence",
      sorting: false,
      render: (rowData) =>
        rowData?.totalConfidence ? (
          <Bold style={{ marginLeft: 30 }}>{rowData?.duration}</Bold>
        ) : (
          <div style={{ paddingLeft: "15px" }}>{"-"}</div>
        ),
    },
    {
      field: "time",
      title: "Created Time",
      sorting: false,
      render: (rowData) =>
        rowData?.time ? (
          <Bold>{rowData?.time}</Bold>
        ) : (
          <div style={{ paddingLeft: "15px" }}>{"-"}</div>
        ),
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
      };
      if (query.search) {
        params.query = query.search;
      }
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `/${meetingId}?${queryString.stringify(params)}`;
      }
      getMeetingUrlArbDetails(stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setState({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  return (
    <Fragment>
      <PaymentContainer className="CreateCase" style={{ overflow: "hidden" }}>
        <TableWrapper>
          <CustomTable
            hidePagination={state.lastPage === 1}
            pageSize={state?.data?.length ? state?.data?.length : 10}
            pluralTitle={"Recordings"}
            singularTitle=""
            {...{
              columns,
              data,
              placeholderText,
              MTRef,
            }}
            hideFilterBar
            state={state}
          />
        </TableWrapper>
      </PaymentContainer>
    </Fragment>
  );
};

export default ArbitratorRecordings;
